<template>
    <v-card flat tile outlined style="position: relative;" @click="$emit('click')">
        <v-img :src="page.src" />
        <v-overlay
            absolute
            :value="true"
            v-bind="{
                color: active ? 'white' : 'black',
                class: {
                    'primary--text': active,
                    'font-weight-black': true,
                },
                style: {
                    border: active ? '5px solid var(--v-primary-base)' : undefined,
                },
            }"
        >
            {{ index + 1 }}
        </v-overlay>
    </v-card>
</template>

<script>
export default {
    props: {
        page: { type: Object, default: () => ({}) },
        value: { type: Number, default: 0 },
        index: { type: Number, default: 0 },
    },
    computed: {
        active() {
            return this.value == this.index;
        },
    },
};
</script>

<style></style>
